import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardHeader from '../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import Paginator from '../../shared/components/Paginator';
import MachinesTable from './MachinesTable';
import CardBody from '../../shared/components/CardBody';
import * as machineActions from '../actions/machineActions';
import StateManager from '../../shared/utils/StateManager';

class MachinesCard extends React.Component {

    STATE_MANAGER_KEY;

    constructor(props) {
        super(props);

        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);

        this.STATE_MANAGER_KEY = props.managerKey;
        this.state = StateManager.getState(this.STATE_MANAGER_KEY);
    }

    componentWillMount() {
        this.props.machineActions.getMachinesStates();
        this.getMachines();
    }

    componentDidUpdate(prevProps, prevState) {
        if ( prevState.search !== this.state.search
            || prevState.filter !== this.state.filter
            || prevState.page !== this.state.page ) {
            this.getMachines();
        }
        StateManager.saveState(this.STATE_MANAGER_KEY, this.state);
    }

    getMachines() {
        const {
            machineActions,
            includeOnlyContractorMachines,
            includeOnlyCompanyMachines,
        } = this.props;

        machineActions.getMachines(
            this.state.page,
            this.state.search,
            this.state.filter,
            this.props.companyId,
            includeOnlyContractorMachines,
            includeOnlyCompanyMachines,
        );
    }

    onRefresh() {
        this.getMachines();
    }

    onSearch(search) {
        this.setState({ search: search, page: 1 });
    }

    onPage(page) {
        this.setState({ page });
    }

    renderFilterName() {
        const states = _.keyBy(this.props.machinesStates, 'id');
        if ( states && states[this.state.filter] ) {
            return states[this.state.filter].name;
        }
        return '';
    }

    renderHeaderOptions() {

        const filterOptions = this.props.machinesStates.map((machineState) => {
            return {
                title: machineState.name,
                active: machineState.id === this.state.filter,
                onClick: () => {
                    this.setState({ filter: machineState.id, page: 1 });
                },
            };
        });

        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                onSearch={this.onSearch}
                searchText={this.state.search}
                filterOptions={filterOptions}
            />
        );
    }

    render() {
        const {
            machinesLoading,
            machines,
            machinesError,
            machinesPagination,
            companyColumn,
        } = this.props;

        return (
            <Row>
                <Card loading={machinesLoading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TODA_LA_MAQUINARIA').toUpperCase()}
                        subtitle={this.renderFilterName()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody>
                        <MachinesTable
                            data={machines}
                            error={machinesError}
                            companyColumn={companyColumn}
                        />
                        <Paginator
                            data={machinesPagination}
                            onPage={this.onPage}
                        />
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

const mapStateToProps = state => {

    let errorMessage = state.machines.machinesError;
    if ( !errorMessage && Object.keys(state.machines.machines).length === 0 && !state.machines.machinesLoading ) {
        errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
    }
    return ( {
        machines: state.machines.machines,
        machinesPagination: state.machines.machinesPagination,
        machinesLoading: state.machines.machinesLoading,
        machinesError: errorMessage,
        machinesStates: state.machines.machinesStates,
    } );
};

const mapDispatchToProps = dispatch => ( {
    machineActions: bindActionCreators(machineActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(MachinesCard);

MachinesCard.propTypes = {
    companyId: PropTypes.string,
    includeOnlyContractorMachines: PropTypes.bool,
    includeOnlyCompanyMachines: PropTypes.bool,
    companyColumn: PropTypes.oneOf('contractor', 'outsource'),
    managerKey: PropTypes.string,
};

MachinesCard.defaultProps = {
    companyId: null,
    includeOnlyContractorMachines: false,
    includeOnlyCompanyMachines: false,
    companyColumn: 'outsource',
    managerKey: 'MACHINES_CARD',
};



// WEBPACK FOOTER //
// ./src/app/machines/components/MachinesCard.jsx